import { render, staticRenderFns } from "./hazopRiskRegister.vue?vue&type=template&id=4ea57e14"
import script from "./hazopRiskRegister.vue?vue&type=script&lang=js"
export * from "./hazopRiskRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea57e14')) {
      api.createRecord('4ea57e14', component.options)
    } else {
      api.reload('4ea57e14', component.options)
    }
    module.hot.accept("./hazopRiskRegister.vue?vue&type=template&id=4ea57e14", function () {
      api.rerender('4ea57e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/hazop/risk/hazopRiskRegister.vue"
export default component.exports